import React from 'react';

import PropTypes from 'prop-types';

import Breadcrumbs from './Breadcrumbs';
import Toggler from './Toggler';

const Topbar = ({ children }) => <div className="cr-topbar">{children}</div>;

Topbar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Topbar;
export { Toggler, Breadcrumbs };
